<template>
  <div class="img-list">
    <div v-if="getType == 'title'">
      <div>
        <div
          :class="handelLastName(_getDownloadUrl(item)) ? 'img-content' : 'text-content'"
          v-for="(item, key) in imgList.activePhotoFiles"
          :key="key"
        >
          <a v-if="!handelLastName(_getDownloadUrl(item))" :href="_getDownloadUrl(item)" :download="_getDownloadUrl(item)">
            <i class="el-icon-document"></i>
            {{ getFileName(item).model }}
          </a>
          <img v-else :src="_getDownloadUrl(item)" />
          <!-- 删除icon -->
          <div class="del">
            <i @click="handleFileRemove(item, key, imgList)" class="el-icon-delete"></i>
          </div>
          <!-- 放大icon -->
          <div class="layer" v-if="handelLastName(_getDownloadUrl(item))" @click="handleFileEnlarge(item)">
            <i class="el-icon-view"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="getType == 'radio'">
      <div
        :class="handelLastName(_getDownloadUrl(item)) ? 'img-content' : 'text-content'"
        v-for="(item, key) in imgList.items[0].photos"
        :key="key"
      >
        <a v-if="!handelLastName(_getDownloadUrl(item))" :href="_getDownloadUrl(item)" :download="_getDownloadUrl(item)">
          <i class="el-icon-document"></i>
          {{ getFileName(item).model }}
        </a>
        <img v-else :src="_getDownloadUrl(item)" />
        <!-- 删除icon -->
        <div class="del">
          <i @click="handleFileRemove(item, key, imgList)" class="el-icon-delete"></i>
        </div>
        <!-- 放大icon -->
        <div class="layer" v-if="handelLastName(_getDownloadUrl(item))" @click="handleFileEnlarge(item)">
          <i class="el-icon-view"></i>
        </div>
      </div>
    </div>
    <div v-if="getType == 'check'">
      <div
        :class="handelLastName(_getDownloadUrl(item)) ? 'img-content' : 'text-content'"
        v-for="(item, key) in handleCheck"
        :key="key"
      >
        <div v-if="!handelLastName(_getDownloadUrl(item))" class="del">
          <img src="/entrance/img/document.png" />
        </div>
        <a v-if="!handelLastName(_getDownloadUrl(item))" :href="_getDownloadUrl(item)" :download="_getDownloadUrl(item)">{{
          getFileName(item).model
        }}</a>
        <img v-else :src="_getDownloadUrl(item)" />
        <!--非图片删除 黑色 -->
        <div class="del" v-if="!handelLastName(_getDownloadUrl(item))">
          <img src="/entrance/img/delete.png" alt="" @click="handleFileRemove(item, key, imgList)" />
        </div>
        <!-- 删除icon -->
        <div class="del" v-if="handelLastName(_getDownloadUrl(item))">
          <img src="/entrance/img/ashbinn.png" alt="" @click="handleFileRemove(item, key, imgList)" />
        </div>
        <!-- 放大icon -->
        <div class="layer" v-if="handelLastName(_getDownloadUrl(item))" @click="handleFileEnlarge(item)">
          <img src="/entrance/img/see.png" alt="" />
        </div>
      </div>
    </div>
    <div>
      <!-- accept=".jpg,.png,.bmp,.jpeg" -->
      <el-upload
        :show-file-list="false"
        class="avatar-uploader"
        action="/fill/api/v1/upload"
        list-type="picture-card"
        :on-success="
          (res, file, fileList) => {
            return handleSuccess1(res, file, fileList, imgList, getType, getIndex)
          }
        "
        :on-progress="onProgress"
        :before-upload="beforeUpload1"
      >
        <i slot="default" class="el-icon-plus"></i>
      </el-upload>
    </div>
    <el-dialog
      append-to-body
      title="预览"
      v-if="isEnlargeImage"
      :visible.sync="isEnlargeImage"
      size="large"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      top="8%"
      width="60%"
    >
      <img @click="isEnlargeImage = false" style="width: 100%" :src="enlargeImage" />
    </el-dialog>
    <div class="fixed inset-0 bg-gray-100 bg-opacity-75" style="z-index: 99999" v-if="upLoadDataLoading">
      <el-progress
        class="flex justify-center relative top-1/2 transform -translate-y-1/2"
        type="circle"
        :percentage="percentage"
      ></el-progress>
    </div>
  </div>
</template>
<script>
import { file } from 'jszip'
import mixins from './mixins'
export default {
  mixins: [mixins],
  props: {
    imgList: Object,
    xArray: Array,
    getType: String,
    getIndex: Number,
    newOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isEnlargeImage: false, //放大图片
      enlargeImage: '', //放大图片地址
      titleImgRow: null, //复制的scope.row
      radioImgRow: null,
      checkImgRow: null,
      checkShow: null,
      url: null,
      upLoadDataLoading: false,
      percentage: 0
    }
  },
  computed: {
    handleCheck() {
      const tpi = this.imgList.tempPhotosItems
      for (let i = 0; i < tpi.length; i++) {
        if (this.newOptions[this.getIndex].id == tpi[i].optionId) {
          return (tpi[i].photos || []).map(item => {
            return item
          })
        }
      }
      return []
    },
    getFileName() {
      return function (url) {
        // let index = url.lastIndexOf('\/')
        let str = this.convertFileName(url) // url.substring(index + 1, url.length)
        return { model: str }
      }
    }
  },
  methods: {
    convertFileName(filename = '') {
      filename = decodeURIComponent(filename)
      const splits = filename.split('/')
      filename = splits.pop()
      if (filename.indexOf('_')) {
        let [, ...names] = filename.split('_')
        filename = names.join('_')
      }
      return filename
    },
    handleFileEnlarge(_url) {
      //放大图片
      if (_url) {
        this.enlargeImage = this._getDownloadUrl(_url)
        this.isEnlargeImage = !this.isEnlargeImage
      }
    },
    handleFileRemove(file, i, row) {
      //删除图片
      let that = this
      this.$confirm('是否删除此附件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message.success('删除成功')
          if (this.getType == 'title') {
            this.titleImgRow = row
            // if(!that.imgList.tempData){
            that.imgList.activePhotoFiles.splice(i, 1)
            this.setTitleRow(null, this.getType, null, that.imgList.activePhotoFiles)
            // }else if(that.imgList.tempData){
            // that.imgList.tempData.activePhotoFiles.splice(i, 1);
            // this.setTitleRow(null, this.getType, null, that.imgList.tempData.activePhotoFiles)
            // }
          } else if (this.getType == 'radio') {
            that.imgList.items[0].photos.splice(i, 1)
            this.radioImgRow = row
            this.setTitleRow(null, this.getType, null, that.imgList.items[0].photos)
          } else if (this.getType == 'check') {
            let itemIndex = ''
            for (let idx = 0; idx < this.imgList.tempPhotosItems.length; idx++) {
              for (let idx1 = 0; idx1 < this.imgList.tempPhotosItems[idx].photos.length; idx1++) {
                if (this.imgList.tempPhotosItems[idx].photos[idx1] == file) {
                  itemIndex = idx
                  break
                }
              }
            }
            this.imgList.tempPhotosItems[itemIndex].photos.splice(i, 1)
            that.checkImgRow = row
            that.setTitleRow(null, that.getType, that.getIndex, this.imgList.tempPhotosItems[itemIndex].photos)
          }
        })
        .catch(meg => console.log(meg))
    },
    setTitleRow(file, type, index, delList) {
      let url1 = []
      //添加状态
      if (!delList) {
        if (file.response) {
          if (this.getType == 'title') {
            //  if(this.imgList.tempData){
            //  url1 = this.imgList.tempData.activePhotoFiles || [];
            //  }else{
            url1 = this.imgList.activePhotoFiles || []
            //  }
          } else if (this.getType == 'radio') {
            url1 = this.imgList.items[0].photos || []
          } else if (this.getType == 'check') {
            url1 = this.handleCheck || []
          }
          url1.push(file.response.data.url)
        } else {
          if (this.getType == 'title') {
            url1 = this.imgList.activePhotoFiles || []
          } else if (this.getType == 'radio') {
            url1 = this.imgList.items[0].photos || []
          } else if (this.getType == 'check') {
            url1 = this.handleCheck || []
          }
          url1.push(file.url.split('=')[1])
        }
      } else {
        //删除状态
        url1 = delList
      }
      const photos = url1
      if (type == 'title') {
        this.titleImgRow.activePhotoFiles = photos
        if (this.xArray.findIndex(it => it.questonId === this.titleImgRow.questonId) === -1) {
          this.xArray.push(this.titleImgRow)
        }
      } else if (type == 'radio') {
        this.radioImgRow.items[0].photos = photos
        if (this.xArray.findIndex(it => it.questonId === this.radioImgRow.questonId) === -1) {
          this.xArray.push(this.radioImgRow)
        }
      } else if (type == 'check') {
        this.checkImgRow.tempPhotosItems[index].photos = photos
        this.checkImgRow.items.forEach(item => {
          if (item.optionId === this.checkImgRow.tempPhotosItems[index].optionId) {
            item.photos = photos
            const idIdx = this.xArray.findIndex(it => it.questonId === this.checkImgRow.questonId)
            if (idIdx === -1) {
              this.xArray.push(this.checkImgRow)
            } else {
              this.xArray.splice(idIdx, 1, this.checkImgRow)
            }
          }
        })
      }
    },
    handleSuccess1(res, file, fileList, row, type, index) {
      // if(row.tempData){
      // this.titleImgRow = row.tempData
      // }else if(!row.tempData){
      if (type == 'title') {
        this.titleImgRow = row
      } else if (type == 'radio') {
        this.radioImgRow = row
      } else if (type == 'check') {
        this.checkImgRow = row
      }
      // }
      if (res && res.code !== 0) {
        // 错误提示
        this.$message.error(res.msg)
        // 删除
        const idx = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(idx, 1)
      }
      // row.activePhotoFiles.push(file.response.data.url);
      //  console.log(JSON.stringify(row,null,2));
      this.setTitleRow(file, type, index)
      this.upLoadDataLoading = false
    },
    beforeUpload1(file) {
      const isLt30M = file.size / 1024 / 1024 / 30 < 1
      if (!isLt30M) {
        this.$message.error('上传文件大小不能超过 30MB!')
        return false
      }
      this.upLoadDataLoading = true
      /* if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/x-ms-bmp"
      ) {
        this.$message.error("只能上传jpg/jpeg/png/bmp文件");
        return false;
      } */
    },
    onProgress(event, file, fileList) {
      this.percentage = Math.floor(event.percent)
    },
    handelLastName(item) {
      const reg = /\.(jpg|png|gif|bmp|jpeg|ico|svg|tiff|tif|webp)$/i;
      return reg.test(item)
    }
  }
}
</script>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}
::v-deep.el-dialog__body img {
  height: 100% !important;
}
.img-list {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.img-list .text-content {
  display: flex;
  justify-content: space-between;
  border: 1px solid #d1dbe5;
  border-radius: 4px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  margin-bottom: 5px;
  padding: 2px 5px;
  cursor: pointer;
  a {
    font-size: 12px;
    // height: 20px;
    // line-height: 10px;
  }
  i {
    font-size: 12px;
    color: #000;
  }
  .del {
    img {
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-top: 1px;
    }
  }
}
.img-list .img-content {
  display: flex;
  align-items: center;
  position: relative;
  display: inline-block;
  width: 80px;
  height: 80px;
  padding: 5px;
  margin: 5px 20px 20px 0;
  border: 1px solid #d1dbe5;
  border-radius: 4px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  img {
    display: block;
    width: 60px;
    height: 60px;
    margin: 0 auto;
    border-radius: 4px;
  }
  .name {
    margin-top: 10px;
    div {
      width: 90%;
      text-overflow: ellipsis;
      overflow: hidden;
      height: 25px;
      line-height: 25px;
    }
  }
  .del {
    display: inline-block;
    width: 15px;
    height: 15px;
    position: absolute;
    bottom: 38px;
    right: 16px;
    color: #c5c5c5;
    cursor: pointer;
    font-size: 1.1em;
    z-index: 5;
    i {
      display: inline-block;
      width: 15px;
      height: 15px;
      color: #c5c5c5;
    }
    img {
      display: inline-block;
      width: 17px;
      height: 17px;
      margin-top: 1px;
      color: #c5c5c5;
    }
  }
  .layer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 80px;
    color: #c5c5c5;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.4);
    i {
      display: inline-block;
      color: #c5c5c5;
      width: 15px;
      height: 15px;
      margin-top: 30px;
      margin-right: 20px;
      cursor: pointer;
    }
    img {
      display: inline-block;
      color: #c5c5c5;
      width: 17px;
      height: 17px;
      margin-top: 26px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
.img-list .img-content:hover .del,
.img-list .img-content:hover .layer {
  opacity: 1;
}
.img-list .img-content .del,
.img-list .img-content .layer {
  opacity: 0;
  transition: all 0.3s;
}
//上传图片样式
.avatar-uploader {
  .el-upload-list--picture-card .el-upload-list__item {
    height: 80px;
    width: 80px;
    transition: none !important;
  }

  ::v-deep.el-upload--picture-card {
    margin-top: 5px;
    height: 80px;
    width: 80px;
    line-height: 90px;
  }
}
::v-deep .el-upload-list {
    li {
      height: 80px;
      width: 80px;
    }
  }
</style>
